import { CalendarDaysIcon } from '@heroicons/react/24/outline';
import type { ToolManifest } from '../types';

const manifest: ToolManifest = {
  slug: 'isg-takvim',
  href: '/araclar/isg-takvim',
  title: '6331 İSG Yıllık Aksiyon Takvimi',
  shortLabel: 'İSG Takvim',
  eyebrow: '6331 · 2026 mevzuatı · Yıllık plan',
  description:
    'İşyerinizin tehlike sınıfı ve çalışan sayısını seçin — risk değerlendirme yenileme, İSG eğitim, kurul toplantı, periyodik kontrol, tatbikat, sağlık muayenesi gibi tüm 6331 yıllık aksiyonları periyot ve mevzuat referansıyla tek tabloda görün.',
  bullets: [
    '12+ yıllık zorunluluk tek takvimde',
    'Tehlike sınıfı + çalışan sayısına göre dinamik',
    'Mevzuat referansı (RG no + Madde) her satırda',
    'Yazdırılabilir / PDF kaydı',
  ],
  audience: 'OSGB Sorumlu Müdür · iş güvenliği uzmanı · İşveren vekili · İK / İdari işler',
  icon: CalendarDaysIcon,
  mevzuat: [
    { no: '6331', ad: 'İş Sağlığı ve Güvenliği Kanunu' },
    { no: '28512', ad: 'İş Sağlığı ve Güvenliği Risk Değerlendirmesi Yönetmeliği', madde: 'Md 12' },
    { no: '33212', ad: 'Çalışanların İş Sağlığı ve Güvenliği Eğitimlerinin Usul ve Esasları Hakkında Yönetmelik (2026)', madde: 'Md 14' },
    { no: '28532', ad: 'İş Sağlığı ve Güvenliği Kurulları Yönetmeliği', madde: 'Md 9' },
    { no: '28628', ad: 'İş Ekipmanlarının Kullanımında Sağlık ve Güvenlik Şartları Yönetmeliği', madde: 'EK-III' },
    { no: '28681', ad: 'İşyerlerinde Acil Durumlar Yönetmeliği', madde: 'Md 13 (tatbikat), Md 14 (yenileme)' },
    { no: '28713', ad: 'İşyeri Hekimi Görev, Yetki, Sorumluluk Yönetmeliği', madde: 'Md 9' },
    { no: '28750', ad: 'Çalışan Temsilcisi Seçim Tebliği', madde: 'Md 7 (sayı), Md 8 (görev süresi)' },
    { no: '28695', ad: 'KKD\'lerin İşyerlerinde Kullanılması Yönetmeliği', madde: 'Md 8' },
    { no: '28512', ad: 'İş Sağlığı ve Güvenliği Hizmetleri Yönetmeliği', madde: 'Md 14 (İSG-KATİP)' },
    { no: '26735', ad: 'Binaların Yangından Korunması Hakkında Yönetmelik', madde: 'Md 99 (söndürücü), Md 129 (tatbikat)' },
  ],
  imzaTipi: 'YOK',
  raporlama: 'YAZDIR',
  faqs: [
    {
      question: '6331 yıllık plan / İSG yıllık aksiyon takvimi nedir?',
      answer:
        '6331 sayılı İş Sağlığı ve Güvenliği Kanunu ve ilgili yönetmeliklerin işyerine yüklediği — risk değerlendirmesi yenileme, çalışan İSG eğitimi tekrarı, İSG Kurulu toplantısı, yangın tatbikatı, ekipman periyodik kontrolü, çalışan periyodik sağlık muayenesi gibi — tüm yinelenen yükümlülüklerin tek bir yıllık plana dökümüdür. Plan, işyerinin tehlike sınıfına (Az / Tehlikeli / Çok Tehlikeli) ve çalışan sayısına göre dinamik olarak şekillenir.',
    },
    {
      question: 'Risk değerlendirmesi ne zaman yenilenir?',
      answer:
        '28512 sayılı Risk Değerlendirmesi Yönetmeliği Madde 12 uyarınca risk değerlendirmesi: Az Tehlikeli işyerlerinde 6 yılda bir, Tehlikeli işyerlerinde 4 yılda bir, Çok Tehlikeli işyerlerinde 2 yılda bir yenilenir. Bu periyotlar minimumdur; ölümlü/yaralanmalı kaza, üretim/çalışma yöntemi değişikliği, yeni teknoloji kullanımı veya iş yeri taşınması durumlarında ek olarak yenileme zorunludur.',
    },
    {
      question: 'Çalışan İSG eğitimi kaç yılda bir tekrarlanır?',
      answer:
        '02.04.2026 tarihinde yürürlüğe giren 33212 sayılı Çalışanların İş Sağlığı ve Güvenliği Eğitimlerinin Usul ve Esasları Hakkında Yönetmelik Madde 14/1 hükümleri: Az Tehlikeli işyerinde 3 yılda bir, Tehlikeli işyerinde 2 yılda bir, Çok Tehlikeli işyerinde 1 yılda bir. Tekrar eğitiminin asgari süresi 8 ders saatidir (Madde 14/2); her ders saati 45 dakika eğitim + 15 dakika molayı kapsar (Madde 4). İşe başlamada eğitim yüz yüze yapılır (Madde 7/3); temel eğitim 3 ay içinde tamamlanır (Madde 8/1).',
    },
    {
      question: 'İSG Kurulu kaç ayda bir toplanır?',
      answer:
        '28532 sayılı İSG Kurulları Yönetmeliği Madde 9 uyarınca kurul ayda en az bir kez toplanır. Kurul, tehlikeli işyerlerinde bu sürenin 2 ay, az tehlikeli işyerlerinde 3 ay olarak belirlenmesine karar verebilir. Kurul, 50 ve üzeri çalışanı olan ve 6 aydan fazla süren işlerde kurulması zorunludur. Toplantıda alınan kararlar tutanağa bağlanıp imzalanır ve kurulun özel dosyasında saklanır.',
    },
    {
      question: '50\'den az çalışanı olan işyeri kurul kurmak zorunda mı?',
      answer:
        'Hayır. 28532 sayılı Yönetmelik Madde 4 uyarınca İSG Kurulu zorunluluğu yalnızca 50 ve üzeri çalışanı olan ve 6 aydan fazla süren işler için geçerlidir. Daha küçük işyerlerinde işveren, iş güvenliği uzmanlarıyla birlikte gerekli kararları alır; ayrıca iki ve daha fazla çalışanı olan işyerlerinde çalışan temsilcisi görevlendirilmesi zorunludur (28750 sayılı Tebliğ Md 7).',
    },
    {
      question: 'Çalışan temsilcisi nasıl ve ne sıklıkla seçilir?',
      answer:
        '28750 sayılı Tebliğ Madde 7 uyarınca çalışan sayısına göre temsilci sayısı: 2-50 arası 1, 51-100 arası 2, 101-500 arası 3, 501-1000 arası 4, 1001-2000 arası 5, 2001 ve üzeri 6 temsilci. Temsilciler oy ile seçilir, görev süresi 5 yıldır (Madde 8/2). İşyerinde yetkili sendika varsa, sendika temsilcisi seçimsiz olarak çalışan temsilcisi olur (Madde 8); birden fazla çalışan temsilcisi varsa baş temsilci, çalışan temsilcileri arasında ayrı bir seçimle belirlenir (Madde 8/7).',
    },
    {
      question: 'Yangın tatbikatı yılda kaç kez yapılır?',
      answer:
        'Tatbikat sayısı 28681 sayılı Acil Durumlar Yönetmeliği Madde 13 uyarınca yılda en az 1 kez. 26735 sayılı Binaların Yangından Korunması Hakkında Yönetmelik Madde 129 da "binada senede en az 1 kez söndürme ve tahliye tatbikatı yapılır" hükmünü getirir; otel, hastane, AVM gibi yüksek riskli binalarda işveren daha sık tatbikat planlayabilir. Tatbikat sonrası rapor düzenlenir; eksiklikler düzeltici faaliyete bağlanır.',
    },
    {
      question: 'Hangi ekipmanlar yıllık periyodik kontrole tabidir?',
      answer:
        '25.04.2013 / 28628 sayılı İş Ekipmanları Yönetmeliği EK-III kapsamında: basınçlı kaplar (kompresör, kazan, hidrofor), kaldırma ekipmanları (forklift, vinç, yük asansörü), elektrik tesisatı, topraklama, paratoner, yangın tesisatı, tezgahlar kural olarak yıllık periyodik kontrole tabidir; yapı iskeleleri 6 ayda bir kontrol edilir. İnsan taşıyan asansörler ayrı yönetmeliğe (Asansör Periyodik Kontrol Yönetmeliği, Resmî Gazete 30411) tabidir. 23.12.2025 / 33116 sayılı revizyon ile "ekipman muayene kuruluşu" tanımı getirildi ve Ek-2\'de zorunlu kuruluş kapsamı 4 ekipmandan 8 ekipmana çıkarıldı (yürürlük 1.1.2027). Ekipman bazında kontrol maddeleri için Ekipman Kontrol Listesi aracını kullanın.',
    },
    {
      question: 'Çalışan periyodik sağlık muayenesi ne sıklıkla yapılır?',
      answer:
        '28713 sayılı İşyeri Hekimi Yönetmeliği Madde 9 uyarınca: Az Tehlikeli işyerinde 5 yılda bir, Tehlikeli işyerinde 3 yılda bir, Çok Tehlikeli işyerinde yılda 1. Özel risk grupları (gebe, emziren, 18 yaş altı, 50 yaş üstü, kronik hastalığı olan) ayrıca takip edilir. İşe giriş ve iş değişikliğinde özel muayene yapılır.',
    },
    {
      question: 'İSG yıllık planı yapmazsam ceza var mı?',
      answer:
        'Evet. 6331 sayılı Kanun Madde 26 uyarınca eğitim eksikliği, risk değerlendirmesi yapmama, periyodik kontrol yaptırmama, kurul oluşturmama gibi ihlaller idari para cezası gerektirir. Cezalar her yıl yeniden değerleme oranıyla güncellenir; tehlike sınıfı yükseldikçe ve çalışan sayısı arttıkça katlanır. Yıllık plan, denetimde kanıt belgesi olarak da işlev görür — planı olan işveren proaktif sayılır.',
    },
    {
      question: 'Bu takvimi nasıl güncel tutarım?',
      answer:
        'İSG mevzuatı yılda birkaç kez güncellenir (örn: 2026\'da NACE Tehlike Sınıfları Tebliği ve İSG Eğitim Yönetmeliği yenilendi). Riskmatik araçları her mevzuat güncellemesinde revize edilir. Daha fazlası için Riskmatik\'e ücretsiz kayıt olun — modüller bu takvimi kişiye özel hatırlatma + otomatik raporlamaya dönüştürür.',
    },
  ],
  seo: {
    title: '6331 İSG Yıllık Aksiyon Takvimi 2026 | Riskmatik',
    description:
      'Tehlike sınıfı ve çalışan sayısına göre yıllık İSG takvimi: risk analizi, eğitim, kurul, tatbikat, periyodik kontrol ve sağlık muayenesi periyotları, ücretsiz.',
    keywords:
      '6331 yıllık plan, isg yıllık aksiyon takvimi, isg yükümlülükleri 2026, risk değerlendirme yenileme periyodu, isg eğitim tekrar süresi, isg kurulu toplantı sıklığı, çalışan temsilcisi seçimi, periyodik kontrol takvimi, isg yıllık çalışma planı',
    canonicalPath: '/araclar/isg-takvim',
    featureList: [
      "Tehlike sınıfı ve çalışan sayısına göre yıllık İSG yükümlülük takvimi",
      "Risk değerlendirmesi, eğitim, İSG kurulu, çalışan temsilcisi, periyodik kontrol, sağlık gözetimi ve tatbikat periyotları",
      "Her yükümlülük için mevzuat dayanağı ve sorumlu kişi",
      "50 ve üzeri çalışanda İSG kurulu zorunluluğu ve toplantı sıklığı",
      "Çalışan sayısına göre çalışan temsilcisi sayısı",
      "Yazdırılabilir / PDF olarak kaydedilebilir takvim",
      "Ücretsiz, kayıt gerektirmez",
    ],
    lastmod: '2026-10-18',
    priority: '0.9',
    changefreq: 'monthly',
  },
  order: 5,
  enabled: true,
  launchedAt: '2026-05-07',
  topics: ['takvim', 'yillik-plan', 'periyot', 'aksiyon-takvimi', 'zamanlama', 'tatbikat-tarihi', 'egitim-tarihi', 'periyodik-kontrol-tarihi', '6331', 'tehlike-sinifi', 'isg-takvimi'],
  intent: 'takvim',
  spamCapacity: 5,
  bridge: {
    href: '/isg-yazilimi',
    etiket: 'Yıllık İSG planını tek panelden yöneten platformu görün',
  },
};

export default manifest;
